<div #inputContainer class="min-w-[200px]">
  <vs-input-container class="relative">
    <vs-icon slot="start" name="search-md"></vs-icon>

    <input
      #input
      #trigger="cdkOverlayOrigin"
      cdkOverlayOrigin
      class="min-h-[40px] max-h-[40px] pr-8"
      [value]="(value$ | async)?.name ?? ''"
      [placeholder]="placeholder"
      (click)="toggle()"
      (input)="onInputChanged(input.value)"
    />

    <!-- Clear button -->
    <button
      type="button"
      aria-label="Clear customer search"
      class="absolute right-2 mt-1 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
      *ngIf="(value$ | async) || (searchQuery$ | async)"
      (click)="clearSelection(input)"
    >
      <vs-icon name="x"></vs-icon>
    </button>
  </vs-input-container>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="overlayOpen"
  [cdkConnectedOverlayOffsetX]="-input.offsetLeft"
  [cdkConnectedOverlayFlexibleDimensions]="true"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="8"
  (overlayOutsideClick)="$event.target !== input ? (overlayOpen = false) : null"
>
  <vs-menu *vsLet="customers$ | async as customers" [style.width.px]="inputContainer.offsetWidth" class="my-2 min-h-0">
    <ng-container *vsLet="loading$ | async as loading">
      <ng-container *ngIf="loading; else customerResults">
        <p class="px-2 py-1 text-sm font-medium text-gray-900">Searching...</p>
      </ng-container>

      <ng-template #customerResults>
        <ng-container *ngIf="customers?.length; else noCustomers">
          <button
            *ngFor="let customer of customers"
            vs-menu-item
            (click)="selectValueChanged(customer); input.value = ''"
          >
            <div class="flex gap-2 justify-between">
              <div class="flex gap-4">
                <vs-user-avatar
                  class="h-8 w-8 self-center"
                  [config]="{ photoUrl: customer?.user?.photoURL ?? '' }"
                ></vs-user-avatar>

                <div class="flex flex-col">
                  <p class="text-sm font-medium text-gray-900" [class.mt-1]="!customer.name">
                    {{ customer.name }}
                  </p>
                  <p *ngIf="customer.name" class="text-xs font-normal text-gray-600">
                    {{ customer.email }}
                  </p>
                  <p *ngIf="customer.address as address" class="text-xs font-normal text-gray-500">
                    {{ address | address }}
                  </p>
                </div>
              </div>

              <div class="flex justify-end w-6">
                <vs-icon *ngIf="value?.id === customer.id" size="18" name="check" class="self-center"></vs-icon>
              </div>
            </div>
          </button>

          <!-- Load More Button -->
          <div *ngIf="hasMore$ | async" class="flex justify-center p-2 border-t border-gray-200">
            <button
              vs-button
              [disabled]="loadingMore$ | async"
              (click)="loadMore()"
              appearance="clear"
              size="sm"
              class="w-full"
            >
              <vs-icon *ngIf="loadingMore$ | async" name="loading-01" class="animate-spin mr-2"></vs-icon>
              <span class="text-sm">{{ (loadingMore$ | async) ? 'Loading...' : 'Load More' }}</span>
            </button>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #noCustomers>
        <p class="px-2 py-1 text-sm font-medium text-gray-900">No customers were found</p>
      </ng-template>
    </ng-container>
  </vs-menu></ng-template
>
